/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Autocomplete,
  Box,
  //Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  // FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  // Slider,
  // Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import TaxiAlertIcon from "@mui/icons-material/TaxiAlert";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PlaceIcon from "@mui/icons-material/Place";
import PieChartIcon from "@mui/icons-material/PieChart";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { CacheContext } from "../Context/cacheContext";
import { ChangeEvent, SyntheticEvent, useContext, useState } from "react";
import { Vocabulary } from "../Utils/Vocabulary";
import style from "../Styles/filters.module.css";
import TuneIcon from "@mui/icons-material/Tune";
import { isMobile } from "../Utils/utils";
import { PillsProps } from "./MainDashboard";
import { VehiclesTab } from "../Utils/autocompleteEnum";
import { GenericModel, StatusModel } from "../Models/Models";
import SellIcon from "@mui/icons-material/Sell";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VerifiedIcon from "@mui/icons-material/Verified";
import SecurityIcon from "@mui/icons-material/Security";
import { useLocation } from "react-router-dom";
import VehicleDetailsFilterCollapsible from "./Generic/VehicleDetailsFilterCollapsible";
import {
  WEBSITE_INTEGRATIONS,
  WebsiteModel,
} from "../Utils/websiteIntegrations";

const ITP_RCA_OPTIONS = [
  { value: "null", label: "Toate" },
  { value: "valid", label: "Valid" },
  { value: "expired", label: "Expirat" },
];

const FILTER_AUTOCOMPLETE_SX = {
  "& .MuiInputBase-root": { padding: "1px 6px", fontSize: "10pt" },
  "& .MuiAutocomplete-tag": { fontSize: "10pt", height: 20 },
  "& .MuiInputLabel-root": { fontSize: "10pt" },
};

const VehicleStatus = {
  NotReceived: Vocabulary.received,
  Unsold: Vocabulary.preparationDelays,
} as const;

const VehicleStatusEN = {
  NotReceived: "NotReceived",
  Unsold: "Unsold",
  UnsoldNotReceived: "Unsold, NotReceived",
  TvaRecovered: "1",
  TvaToBeRecovered: "0",
} as const;

type VehicleStatusProps = {
  users: any;
  data: PillsProps;
  handleSliderChange: (event: any, newValue: any) => void;
  handleMinInputChangeURL: (event: any) => void;
  handleMaxInputChangeURL: (event: any) => void;
  onChangeTextField: (event: any, newValue: any, name: string) => void;
  changeStatusError: (statusError: string) => void;
  changeTvaRecovered: (tvaRecovered: string) => void;
  handleAccordion: (open: boolean) => void;
  setShowIncompleteVehicles: (
    event: ChangeEvent<HTMLInputElement>,
    newValue: boolean,
  ) => void;
  statusesForFilters?: Array<StatusModel>;
  sellingStatuses?: Array<StatusModel>;
  distinctLocationIds?: Array<number | string>;
  distinctPhysicalLocations?: Array<string>;
  brands?: Array<{ id: number; nume: string }>;
  models?: Array<{ id: number; nume: string; brand_id: number }>;
};
export default function VehicleSlider(props: VehicleStatusProps) {
  const {
    users,
    data,
    // handleSliderChange,
    handleMinInputChangeURL,
    handleMaxInputChangeURL,
    onChangeTextField,
    changeStatusError,
    changeTvaRecovered,
    handleAccordion,
    setShowIncompleteVehicles,
    statusesForFilters,
    sellingStatuses,
    distinctLocationIds,
    distinctPhysicalLocations,
    brands,
    models,
  } = props;
  const cacheContext: any = useContext(CacheContext);
  const location = useLocation(); // Used for VehicleDetailsFilterCollapsible
  const [hideFilters, setHideFilters] = useState(true);
  const [eventForMinPrice, setEventForMinPrice] = useState();
  const [eventForMaxPrice, setEventForMaxPrice] = useState();
  const [minPrice, setMinPrice] = useState(data.minPrice);
  const [maxPrice, setMaxPrice] = useState(data.maxPrice);
  function handleChangeMinPrice(event: any) {
    if (eventForMinPrice && event?.key === "Enter")
      handleMinInputChangeURL(eventForMinPrice);
    if (eventForMinPrice && event?.type === "blur")
      handleMinInputChangeURL(eventForMinPrice);
  }
  function handleChangeMaxPrice(event: any) {
    if (eventForMaxPrice && event.key === "Enter")
      handleMaxInputChangeURL(eventForMaxPrice);
    if (eventForMaxPrice && event?.type === "blur")
      handleMaxInputChangeURL(eventForMaxPrice);
  }

  /**
   * Get the users for filtering depending on the status
   * @returns users for filtering
   */
  const getUsersOptions = (): GenericModel[] => {
    switch (data.status) {
      case VehiclesTab.sold:
        return users.vanzatori;
      case VehiclesTab.reserved:
        return users.useriReservari;
      default:
        return users.useriAchizitie;
    }
  };

  /**
   * Maps filter names to their corresponding cache property names
   */
  const cachePropertyMap: Record<string, string> = {
    brand: "brands",
    model: "models",
    bodyType: "bodyworkTypes",
    gearbox: "gearboxes",
    company: "company",
    locations: "locations",
    vehicleTypes: "vehicleTypes",
    purchaseType: "purchaseType",
    websiteIntegrations: "websiteIntegrations",
  };

  /**
   * @returns values for autocomplete from url
   */
  const getValuesForMultipleAutocomplete = (value: string) => {
    const array: GenericModel[] = [];
    let currentValue = (data as any)?.[value];

    if (!currentValue) return array;

    try {
      // Decode URL-encoded values (e.g., for websiteIntegrations)
      if (currentValue.includes("%")) {
        currentValue = decodeURIComponent(currentValue);
      }
      const ids = JSON.parse(currentValue);
      if (!ids?.length) return array;

      const cache = cacheContext.cache;
      const cacheUsers = getUsersOptions();

      const findAndAdd = (searchArray: any[]) => {
        ids.forEach((id: number) => {
          const found = searchArray?.find((item: any) => item.id == id);
          if (found) array.push(found);
        });
      };

      switch (value) {
        case "statusVehicul":
          findAndAdd(sellingStatuses || []);
          break;
        case "physicalVehicleStatus":
          findAndAdd(statusesForFilters || []);
          break;
        case "users":
          findAndAdd(cacheUsers);
          break;
        case "websiteIntegrations":
          // Website integrations use 'code' instead of 'id'
          ids.forEach((code: string) => {
            const found = WEBSITE_INTEGRATIONS.find(
              (item: WebsiteModel) => item.code === code,
            );
            if (found) array.push(found as any);
          });
          break;
        default: {
          const cacheProperty = cachePropertyMap[value];
          if (cacheProperty && cache[cacheProperty]) {
            findAndAdd(cache[cacheProperty]);
          }
          break;
        }
      }
    } catch {
      return array;
    }

    return array;
  };

  /**
   *
   *
   */
  const handleChangeMultipleAutocomplete = (
    event: SyntheticEvent<Element, Event>,
    newValue: GenericModel[],
    changingValue: string,
  ) => {
    const ids: any[] = [];
    if (newValue) {
      newValue?.forEach((item: any) => {
        // Website integrations use 'code' instead of 'id'
        if (changingValue === "websiteIntegrations") {
          ids.push(item?.code);
        } else {
          ids.push(item?.id);
        }
      });
    }
    onChangeTextField(event, ids, changingValue);
  };

  // /**
  //  *
  //  * @returns
  //  */
  // const latestAddedCarsSort = () => {
  //   return (
  //     <Grid item xs={12} md={12}>
  //       <FormControlLabel
  //         label={
  //           <Typography style={{ fontSize: "1rem" }}>
  //             {Vocabulary.latestCars}
  //           </Typography>
  //         }
  //         control={
  //           <Switch
  //             checked={data?.sortByCreatedAt == "true"}
  //             onChange={(event: ChangeEvent<HTMLInputElement>) => {
  //               //props?.setShowIncompleteVehicles?.(e, e.target.checked); daca se vrea doar la vehicule
  //               onChangeTextField(
  //                 event,
  //                 event?.target.checked,
  //                 "sortByCreatedAt"
  //               );
  //             }}
  //           />
  //         }
  //       />
  //     </Grid>
  //   );
  // };

  /**
   *
   */
  const showCarsWithNegativeProfit = () => {
    return (
      <Grid item xs={12} md={12}>
        <FormControlLabel
          label={
            <Typography style={{ fontSize: "10pt" }}>
              {Vocabulary.vehiclesWithNegativeProfit}
            </Typography>
          }
          control={
            <Switch
              checked={data?.showNegativeProfit == "true"}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                //props?.setShowIncompleteVehicles?.(e, e.target.checked); daca se vrea doar la vehicule
                onChangeTextField(
                  event,
                  event?.target.checked,
                  "showNegativeProfit",
                );
              }}
            />
          }
        />
      </Grid>
    );
  };

  return (
    <div className={hideFilters ? style.container : style.containerHide}>
      <div className={hideFilters ? style.filters : style.filtersHide}>
        {/* Filters Title */}
        <Typography
          sx={{
            fontWeight: 600,
            color: "#4d5e80",
            fontSize: "1.1rem",
            position: "sticky",
            top: 0,
            backgroundColor: "#f7f8fa",
            zIndex: 1,
            py: 1,
            px: 1,
            mb: 1,
          }}
        >
          {Vocabulary.filters}
        </Typography>

        {/* Vehicle Details Collapsible Section */}
        <VehicleDetailsFilterCollapsible
          data={data}
          cacheContext={cacheContext}
          location={location}
          getValuesForMultipleAutocomplete={getValuesForMultipleAutocomplete}
          handleChangeMultipleAutocomplete={handleChangeMultipleAutocomplete}
          handleAccordion={handleAccordion}
          brands={brands}
          models={models}
        />

        {/* Date Added Range */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <CalendarTodayIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem", flexShrink: 0 }} />
          <Box sx={{ display: "flex", gap: 0.5, maxWidth: "90%", flex: 1 }}>
            <TextField
              type="date"
              size="small"
              label={Vocabulary.startDate}
              value={data.startDate ?? ""}
              onChange={(e: any) =>
                onChangeTextField(e, e.target.value || null, "startDate")
              }
              sx={{ flex: 1, minWidth: 0, ...FILTER_AUTOCOMPLETE_SX }}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              type="date"
              size="small"
              label={Vocabulary.endDate}
              value={data.endDate ?? ""}
              onChange={(e: any) =>
                onChangeTextField(e, e.target.value || null, "endDate")
              }
              sx={{ flex: 1, minWidth: 0, ...FILTER_AUTOCOMPLETE_SX }}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
        </Box>

        {data?.status != VehiclesTab.sold &&
          data?.status != VehiclesTab.partialVehicles && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CheckCircleIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
              <Autocomplete
                id="statusVehicul"
                freeSolo={false}
                fullWidth
                disablePortal
                multiple
                getOptionLabel={(option: any) => option.nume}
                size="small"
                value={getValuesForMultipleAutocomplete("statusVehicul") ?? []}
                options={sellingStatuses ?? []}
                onChange={(event: any, newValue: any) => {
                  handleChangeMultipleAutocomplete(
                    event,
                    newValue,
                    "statusVehicul",
                  );
                  handleAccordion(false);
                }}
                sx={{ maxWidth: "90%", ...FILTER_AUTOCOMPLETE_SX }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status Vanzare Vehicul"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Box>
          )}
        {data?.status != VehiclesTab.sold &&
          data?.status != VehiclesTab.partialVehicles &&
          statusesForFilters?.length != 0 && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CheckCircleIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
              <Autocomplete
                id="physicalVehicleStatus"
                freeSolo={false}
                fullWidth
                disablePortal
                multiple
                getOptionLabel={(option: any) => option.nume}
                size="small"
                value={
                  getValuesForMultipleAutocomplete("physicalVehicleStatus") ??
                  []
                }
                options={statusesForFilters ?? []}
                onChange={(event: any, newValue: any) => {
                  handleChangeMultipleAutocomplete(
                    event,
                    newValue,
                    "physicalVehicleStatus",
                  );
                  handleAccordion(false);
                }}
                sx={{ maxWidth: "90%", ...FILTER_AUTOCOMPLETE_SX }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status Fizic Vehicul"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Box>
          )}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <PeopleAltIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
          <Autocomplete
            id="users"
            multiple
            freeSolo={false}
            disablePortal
            getOptionLabel={(option: any) => option.nume}
            size="small"
            fullWidth
            options={getUsersOptions()}
            value={getValuesForMultipleAutocomplete("users")}
            onChange={(event: any, newValue: any) => {
              handleChangeMultipleAutocomplete(event, newValue, "users");
              handleAccordion(false);
            }}
            sx={{ maxWidth: "90%", ...FILTER_AUTOCOMPLETE_SX }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Utilizatori"
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", maxWidth: "100%" }}>
          <TaxiAlertIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
          <Autocomplete
            id="company"
            multiple
            freeSolo={false}
            fullWidth
            disablePortal
            getOptionLabel={(option: any) => option.nume_firma}
            size="small"
            options={cacheContext.cache.company}
            value={getValuesForMultipleAutocomplete("company")}
            onChange={(event: any, newValue: any) => {
              handleChangeMultipleAutocomplete(event, newValue, "company");
              handleAccordion(false);
            }}
            sx={{ maxWidth: "90%", ...FILTER_AUTOCOMPLETE_SX }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Firme"
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <LocationCityIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
          <Autocomplete
            id="locations"
            multiple
            disablePortal
            freeSolo={false}
            getOptionLabel={(option: any) => option.nume}
            size="small"
            value={getValuesForMultipleAutocomplete("locations")}
            options={
              distinctLocationIds && distinctLocationIds.length > 0
                ? cacheContext.cache.locations?.filter((location: any) =>
                    distinctLocationIds.includes(location.id),
                  ) || []
                : cacheContext.cache.locations
            }
            onChange={(event: any, newValue: any) => {
              handleChangeMultipleAutocomplete(event, newValue, "locations");
              handleAccordion(false);
            }}
            sx={{ width: "100%", ...FILTER_AUTOCOMPLETE_SX }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={Vocabulary.administrativeLocation}
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <PlaceIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
          <Autocomplete
            id="physical_location_ids"
            multiple
            freeSolo={false}
            getOptionLabel={(option: any) =>
              typeof option === "string" ? option : ""
            }
            size="small"
            value={
              data.physical_location_ids
                ? JSON.parse(decodeURIComponent(data.physical_location_ids))
                : []
            }
            options={distinctPhysicalLocations || []}
            onChange={(event: any, newValue: any) => {
              onChangeTextField(event, newValue, "physical_location_ids");
              handleAccordion(false);
            }}
            sx={{ width: "100%", ...FILTER_AUTOCOMPLETE_SX }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={Vocabulary.physicalLocationText}
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <PieChartIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
          <Autocomplete
            id="vehicleTypes"
            multiple
            freeSolo={false}
            disablePortal
            getOptionLabel={(option: any) => option.nume}
            size="small"
            options={cacheContext.cache.vehicleTypes}
            onChange={(
              event: SyntheticEvent<Element, Event>,
              newValue: any[],
            ) => {
              handleChangeMultipleAutocomplete(event, newValue, "vehicleTypes");
              handleAccordion(false);
            }}
            sx={{ width: "100%", ...FILTER_AUTOCOMPLETE_SX }}
            value={getValuesForMultipleAutocomplete("vehicleTypes")}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tip vehicul"
                variant="outlined"
                size="small"
              />
            )}
          ></Autocomplete>
        </Box>

        {data?.status != VehiclesTab.intermediated && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <SellIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
            <Autocomplete
              id="purchaseType"
              multiple
              freeSolo={false}
              disablePortal
              getOptionLabel={(option: any) => option.nume}
              size="small"
              options={cacheContext.cache.purchaseType}
              onChange={(
                event: SyntheticEvent<Element, Event>,
                newValue: any[],
              ) => {
                handleChangeMultipleAutocomplete(
                  event,
                  newValue,
                  "purchaseType",
                );
                handleAccordion(false);
              }}
              sx={{ width: "100%", ...FILTER_AUTOCOMPLETE_SX }}
              value={getValuesForMultipleAutocomplete("purchaseType")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={Vocabulary.purchaseType}
                  variant="outlined"
                  size="small"
                />
              )}
            ></Autocomplete>
          </Box>
        )}

        {/* Website Integrations Filter */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <VisibilityIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
          <Autocomplete
            id="websiteIntegrations"
            multiple
            freeSolo={false}
            disablePortal
            fullWidth
            getOptionLabel={(option: any) => option.name}
            size="small"
            options={WEBSITE_INTEGRATIONS || []}
            value={
              getValuesForMultipleAutocomplete(
                "websiteIntegrations",
              ) as WebsiteModel[]
            }
            onChange={(event: any, newValue: any) => {
              handleChangeMultipleAutocomplete(
                event,
                newValue,
                "websiteIntegrations",
              );
              handleAccordion(false);
            }}
            sx={{ maxWidth: "90%", ...FILTER_AUTOCOMPLETE_SX }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={Vocabulary.websiteIntegrationsText}
                variant="outlined"
                size="small"
              />
            )}
          />
        </Box>
        <Box sx={{ display: "flex", marginTop: 1 }}>
          <EuroSymbolIcon sx={{ color: "#4d5e80", mr: 2, my: 1.5, fontSize: "0.9rem" }} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <TextField
                value={minPrice
                  ?.toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                size="small"
                onChange={(e: any) => {
                  const numValue = e?.target?.value?.replace(/\s/g, "");
                  setEventForMinPrice(e);
                  setMinPrice(numValue);
                }}
                onBlur={(e: any) => handleChangeMinPrice(e)}
                onKeyUp={(e: any) => {
                  handleChangeMinPrice(e);
                }}
                label="Minim"
                style={{ marginLeft: -8 }}
                InputLabelProps={{ style: { fontSize: "10pt" } }}
                inputProps={{
                  step: 1000,
                  min: 0,
                  type: "text",
                  style: { fontSize: "10pt" },
                }}
              />
              <TextField
                value={maxPrice
                  ?.toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                size="small"
                onChange={(e: any) => {
                  const numValue = e?.target?.value?.replace(/\s/g, "");
                  setEventForMaxPrice(e);
                  setMaxPrice(numValue);
                }}
                onKeyUp={(e: any) => {
                  handleChangeMaxPrice(e);
                }}
                onBlur={(e: any) => handleChangeMaxPrice(e)}
                label="Maxim"
                InputLabelProps={{ style: { fontSize: "10pt" } }}
                inputProps={{
                  step: 1000,
                  min: 0,
                  type: "text",
                  style: { fontSize: "10pt" },
                }}
              />
            </div>
          </div>
        </Box>

        {/* ITP Status */}
        <Box sx={{ display: "flex", alignItems: "center", mt: 1.5 }}>
          <VerifiedIcon sx={{ color: "#4d5e80", mr: 1, my:2, fontSize: "1.1rem" }} />
          <FormControl size="small" fullWidth sx={FILTER_AUTOCOMPLETE_SX}>
            <InputLabel sx={{ fontSize: "10pt" }}>{Vocabulary.itpValidUntil}</InputLabel>
            <Select
              value={data.itpStatus ?? "null"}
              label={Vocabulary.itpValidUntil}
              onChange={(e: any) => onChangeTextField(e, e.target.value, "itpStatus")}
            >
              {ITP_RCA_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: "10pt" }}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* RCA Status */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <SecurityIcon sx={{ color: "#4d5e80", mr: 1, my: 2, fontSize: "1.1rem" }} />
          <FormControl size="small" fullWidth sx={FILTER_AUTOCOMPLETE_SX}>
            <InputLabel sx={{ fontSize: "10pt" }}>{Vocabulary.rcaValidUntil}</InputLabel>
            <Select
              value={data.rcaStatus ?? "null"}
              label={Vocabulary.rcaValidUntil}
              onChange={(e: any) => onChangeTextField(e, e.target.value, "rcaStatus")}
            >
              {ITP_RCA_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: "10pt" }}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Grid
          container
          spacing={2}
          style={{ padding: "5px", marginTop: "5px" }}
        >
          <Grid item xs={12} md={12}>
            <FormControlLabel
              style={{ margin: 0 }}
              label={
                <Typography style={{ fontSize: "10pt" }}>
                  {Vocabulary.incompleteVehicles}
                </Typography>
              }
              control={
                <Switch
                  size="small"
                  checked={data?.showIncompleteVehicles}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setShowIncompleteVehicles(e, e.target.checked);
                  }}
                />
              }
            />
          </Grid>
          {/* {latestAddedCarsSort()} */}
          {data?.status === VehiclesTab.sold && showCarsWithNegativeProfit()}
          <Grid item xs={12} md={12}>
            <FormControlLabel
              style={{ margin: 0 }}
              label={
                <Typography style={{ fontSize: "10pt" }}>
                  {Vocabulary.rarEfectuat}
                </Typography>
              }
              control={
                <Switch
                  size="small"
                  checked={!!data?.rarCompleted}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    onChangeTextField(event, event.target.checked, "rarCompleted");
                  }}
                />
              }
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <FormControlLabel
              style={{ margin: 0 }}
              label={
                <Typography style={{ fontSize: "10pt" }}>
                  {Vocabulary.rarProgramat}
                </Typography>
              }
              control={
                <Switch
                  size="small"
                  checked={!!data?.rarScheduled}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    onChangeTextField(event, event.target.checked, "rarScheduled");
                  }}
                />
              }
            />
          </Grid>
        </Grid>

        {
          <div>
            <div
              style={{
                border: "1px solid #0000001f",
                borderRadius: 10,
                marginTop: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor:
                    data?.tvaRecovered?.toString() ===
                    VehicleStatusEN.TvaToBeRecovered
                      ? "#dbdbdb4d"
                      : "",
                }}
                onClick={() =>
                  data?.tvaRecovered?.toString() ===
                  VehicleStatusEN.TvaToBeRecovered
                    ? changeTvaRecovered("null")
                    : changeTvaRecovered(VehicleStatusEN.TvaToBeRecovered)
                }
              >
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      height: 30,
                      width: 30,
                      backgroundColor: "#7a7a7a63",
                      margin: 10,
                      borderRadius: 10,
                    }}
                  ></div>
                  <p
                    style={{
                      margin: 13,
                      verticalAlign: "center",
                      color: "#4d5e80",
                    }}
                  >
                    {"TVA recuperat"}
                  </p>
                </div>
              </div>

              <Divider />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  backgroundColor:
                    data?.statusError === VehicleStatusEN.Unsold
                      ? "#dbdbdb4d"
                      : "",
                }}
                onClick={() =>
                  data?.statusError === VehicleStatusEN.Unsold
                    ? changeStatusError("null")
                    : changeStatusError(VehicleStatusEN.Unsold)
                }
              >
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      height: 30,
                      width: 30,
                      backgroundColor: "#ffccbb63",
                      margin: 10,
                      borderRadius: 10,
                    }}
                  ></div>
                  <p
                    style={{
                      margin: 13,
                      verticalAlign: "center",
                      color: "#4d5e80",
                    }}
                  >
                    {VehicleStatus.Unsold}
                  </p>
                </div>
              </div>
              <Divider />
              <div
                style={{
                  display: "flex",
                  cursor: "pointer",
                  backgroundColor:
                    data?.statusError === VehicleStatusEN.NotReceived
                      ? "#dbdbdb4d"
                      : "",
                }}
                onClick={() =>
                  data?.statusError === VehicleStatusEN.NotReceived
                    ? changeStatusError("null")
                    : changeStatusError(VehicleStatusEN.NotReceived)
                }
              >
                <div
                  style={{
                    height: 30,
                    width: 30,
                    backgroundColor: "#cc43144d",
                    margin: 10,
                    borderRadius: 10,
                  }}
                ></div>
                <p
                  style={{
                    margin: 13,
                    verticalAlign: "center",
                    color: "#4d5e80",
                  }}
                >
                  {VehicleStatus.NotReceived}
                </p>
              </div>
            </div>
          </div>
        }
      </div>

      {!isMobile() && !hideFilters && (
        <div style={{ position: "absolute", bottom: 10, left: 8 }}>
          <Tooltip title="Filtre">
            <IconButton
              onClick={() => setHideFilters(true)}
              style={{ backgroundColor: "#ff6633", color: "#fff" }}
            >
              <TuneIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  );
}
